import React from 'react';
import {
  Navigate,
  Route,
  Routes,
  BrowserRouter, useLocation
} from 'react-router-dom';
import '@material/react-text-field/dist/text-field.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {ThemeProvider} from '@mui/material/styles';

import {themeDecisions} from 'core/themes/themeDecisions';
import {analytics} from 'core/Analytics';
import {LOGIN, SIGN_UP} from 'core/routes';

import Login from 'modules/Login';
import SignUp from 'modules/SignUp';

import Header from 'components/Header';

import ErrorBoundary from './ErrorBoundary';
import style from './App.module.css';

process.env.REACT_APP_ENV_NAME === 'prod' &&
  analytics.init('jbnoc5/login-j8mth');

function AppRoutes() {
  const location = useLocation();
  return (
    <Routes>
      <Route
        path='/'
        element={<Navigate to={`${LOGIN}${location.search}`} replace />}
      />
      <Route path={LOGIN} element={<Login />} />
      <Route path={SIGN_UP} element={<SignUp />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={themeDecisions}>
        <BrowserRouter>
          <div className={style.container}>
            <Header />
            <AppRoutes />
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
export default App;
